import axios from 'axios';
export default {
  data() {
    return {
      article: []
    };
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(id) {
        this.getArticle(id);
      }
    }
  },
  computed: {
    bgImage() {
      return this.article && this.article.ImageCarousel && this.article.ImageCarousel[0];
    }
  },
  methods: {
    async getArticle(id) {
      const {
        data
      } = await axios.get(`${process.env.VUE_APP_MS_CMS_PATH}/news/${id}`);
      if (data) this.article = data;
    }
  }
};